// extracted by mini-css-extract-plugin
module.exports = {"cardFooter":"IndustryForm_cardFooter__3nrO1","buttons":"IndustryForm_buttons__38gd5","input":"IndustryForm_input__3eRAa"};